import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicPhoneFilled({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        d="M1.9 2.85l.03-.12a.7.7 0 01.54-.47l2.38-.5c.35-.07.7.12.83.45l1 2.47c.12.3.04.61-.19.82l-.9.82a.8.8 0 00-.16.89 7.5 7.5 0 003.36 3.36c.31.14.66.1.89-.16l.82-.9c.2-.23.53-.3.82-.19l2.47 1c.33.14.52.48.44.83l-.49 2.38a.7.7 0 01-.47.54l-.12.04C7.85 15.36.64 8.14 1.89 2.85"
        clipRule="evenodd"
      />
    </svg>
  );
}

SvgBasicPhoneFilled.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicPhoneFilled.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicPhoneFilled svgRef={ref} {...props} />
));
export default ForwardRef;
